import { ErrorContent } from '@/api/interfaces/content/app/errorContent';

export const sendApplicationStepCompensationErrorContent: ErrorContent = {
    stageContent: {
        icon: 'stoerung',
        heading: 'Fehler',
    },
    introContent: {
        content:
            '<p>Bei der Bearbeitung Ihrer Anfrage ist ein unerwartetes Problem aufgetreten. Ein Mitarbeiter wird den Zustand Ihrer Antr&auml;ge pr&uuml;fen. Wir bitten um Ihr Verst&auml;ndnis.</p>\n<p><img alt="" height="102" width="455" src="https://local.deaapi.ewe-netz.de/-/media/dea/bilder/marke/ewe-netz-signatur.png?la=de-de&amp;hash=2409DCFCFE28F673BA24E2969F2F557C" /></p>',
        heading: 'Es ist ein Fehler aufgetreten!',
    },
    contactBoxContent: {
        heading: 'Sprechen wir zusammen.',
        content: 'Für den kostenlosen Kontakt mit uns wählen Sie einfach:',
        telephoneLinks: [
            {
                text: 'T 0441 48080',
            },
        ],
        url: '##',
        text: 'zum Kontaktformular',
    },
    errorButtonsContent: {
        backToOverviewButtonText: 'Zur Übersicht',
    },
};
